module.exports = __webpack_public_path__ + "src/assets/img/share/level2/16a541faa5295d8a1b4473ab752ba26a.png";